import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get voucher
export const getVoucher = createAsyncThunk("voucher/getVoucher", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getVoucher({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all voucher
export const getAllVoucher = createAsyncThunk("voucher/getAllVoucher", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllVoucher();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("voucher/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("voucher/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("voucher/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageVoucher({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get item by id
export const getVoucherById = createAsyncThunk("voucher/getVoucherById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getVoucherById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create voucher
export const createVoucher = createAsyncThunk("voucher/createVoucher", async (createData, { rejectWithValue }) => {
  const { voucherDetails, reference, date, narration, voucherDate, voucherDateBs, voucherType } = createData;
  try {
    const body = JSON.stringify({
      voucherDetails,
      reference,
      date,
      narration,
      voucherDate,
      voucherDateBs,
      voucherType,
    });

    const { data } = await API.createVoucher(body);

    //     // const

    // for (const detail of costCenterDetails) {
    //   await API.createCostCenterDetails(JSON.stringify(detail));
    // }
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
export const updateVoucher = createAsyncThunk("voucher/updateVoucher", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { voucherDetails, reference, date, narration, voucherDate, voucherDateBs, voucherType } = values;
  try {
    const body = JSON.stringify({
      voucherDetails,
      reference,
      date,
      narration,
      voucherDate,
      voucherDateBs,
      voucherType,
    });
    const { data } = await API.updateVoucher(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

export const approveVoucher = createAsyncThunk("voucher/approveVoucher", async (id, { rejectWithValue }) => {
  try {
    const body = JSON.stringify({
      approved: true,
    });
    const { data } = await API.approveVoucher(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk(
  "voucher/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
